module.exports = __webpack_public_path__ + "static/media/icon_mp_like.644a3562.svg";